import {
    IonButton,
    IonCol,
    IonContent,
    IonDatetime,
    IonGrid,
    IonIcon,
    IonInput,
    IonItem,
    IonPage,
    IonPopover,
    IonRadio,
    IonRadioGroup,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonText,
    useIonAlert,
    useIonLoading,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { upsertOnegroup } from "../../../../../../redux/slices/entities/groups";
import "./style.scss";
import {
    callOutline,
    calendarOutline,
    mailOutline,
    eyeOutline,
    eyeOffOutline,
    chevronDownOutline,
    chevronUpOutline,
} from "ionicons/icons";

import ToolBar from "../../../../../../components/ToolBar";
import { useMaskito } from "@maskito/react";
import { DateTime } from "luxon";
import MapComponent from "../../../../../register/pages/MapComponent";
import escudoWebAPI from "../../../../../../services/escudoWebAPI";
import { Geolocation } from "@capacitor/geolocation";
import { Capacitor } from "@capacitor/core";
import { useDispatch } from "react-redux";
import { useFeedback } from "../../../../../../hooks";
import { useHistory, useParams } from "react-router";
import marketInput from "../../../../../../assets/icons/market-input.svg";
import { State } from "../../../../../../models/state";
import { Municipality } from "../../../../../../models/municipality";
import { City } from "../../../../../../models/city";
import anime from "animejs";
import { MEMBERSHIPS } from "../../../../../../constants";
import { addOneMembreship } from "../../../../../../redux/slices/entities/memberships";
import { upsertOneUser } from "../../../../../../redux/slices/entities/users";
import { createUser } from "../../../../../../redux/slices/app";

const CreateMember: React.FC = () => {
    /**
     * Hooks
     */
    const phoneMask = useMaskito({
        options: {
            mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
        },
    });
    const dispatch = useDispatch();
    const [present, disminss] = useIonLoading();
    const feedbackApp = useFeedback();
    const [presetAlert] = useIonAlert();
    const history = useHistory();
    const { id }: any = useParams();

    /**
     * global state
     */

    /**
     * Local state
     */
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedGender, setSelectedGender] = useState<string>("");

    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    /**
     * Estado para los listados de ciudades
     */
    const [states, setAllStates] = useState([]);
    const [allMunicipalities, setAllMunicipalities] = useState([]);
    const [allCities, setAllCities] = useState([]);

    /**
     * Estado para las localidades seleccionadas
     */
    const [selectedState, setSelectedState] = useState<State | null>(null);
    const [selectedMunicipality, setSelectedMunicipality] =
        useState<Municipality | null>(null);
    const [selectedCities, setSelectedCities] = useState<City | null>(null);
    const [showFirstSelect, setShowFirstSelect] = useState(false);
    const [UserMembership, setUserMembership] = useState(0);

    let [user, setUser] = useState({
        name: "",
        last_name: "",
        second_last_name: "",
        cellphone: "",
        email: "",
        inside_number: "",
        outside_number: "",
        street: "",
        zipcode: "",
        date_birth: "",
        gender: "",
        password: "",
        password_confirmation: "",
        latitude: 0,
        longitude: 0,
        colony: "",
        address_city_id: null,
    });

    /**
     * Efecto inicial
     */
    useEffect(() => {
        const get = async () => {
            const state = await escudoWebAPI
                .getAllStates()
                .then((res: any) => res.data.data);
            setAllStates(state);
        };

        get();
    }, []);

    useEffect(() => {
        if (selectedState !== null) {
            const getMunicipalities = async () => {
                const municipalities = await escudoWebAPI
                    .getMunicipalitiesByState(selectedState.state_id)
                    .then((res: any) => res.data.data);
                setAllMunicipalities(municipalities);
            };

            getMunicipalities();
        }
    }, [selectedState]);

    useEffect(() => {
        if (selectedMunicipality !== null) {
            const getCitys = async () => {
                const cities = await escudoWebAPI
                    .getCityByMunicipalite(selectedMunicipality.municipality_id)
                    .then((res: any) => res.data.data);
                setAllCities(cities);
            };

            getCitys();
        }
    }, [selectedMunicipality]);

    const getLocaion = async () => {
        const locationPermissions = await Geolocation.checkPermissions();

        if (Capacitor.getPlatform() === "web") {
            if (locationPermissions.location === "denied") {
                setIsModalOpen(true);
            }
        } else {
            if (locationPermissions.location !== "granted") {
                let permisionReuqest = await Geolocation.requestPermissions();

                let { location } = permisionReuqest;

                if (location === "denied") {
                    setIsModalOpen(true);
                }
            }
        }

        const position = await Geolocation.getCurrentPosition();

        let { latitude, longitude } = position.coords;

        return {
            latitude,
            longitude,
        };
    };

    useEffect(() => {
        getLocaion()
            .then(({ latitude, longitude }: any) => {
                setUser((user: any) => {
                    return {
                        ...user,
                        latitude,
                        longitude,
                    };
                });
            })
            .catch((er) => {
                setIsModalOpen(true);
            });
    }, []);

    /**
     * handle para cambiar el valor de la membresia
     */
    const handleMembershipChange = (e: any) => {
        setUserMembership(e.detail.value);
    };

    /**
     * funcion para crear un nuevo miembro
     */
    const OnCreateMember = async () => {
        present({
            message: "Por favor espere",
        });
        dispatch<any>(
            createUser({
                groupId: id,
                data: user,
                membershipType: UserMembership,
            })
        )
            .unwrap()
            .then(() => {
                presetAlert({
                    header: "Alerta",
                    message: "El usuario se a creado correctamente",
                    backdropDismiss: false,
                    buttons: [
                        {
                            text: "ok",
                            role: "confirm",
                            handler: () => {
                                history.goBack();
                            },
                        },
                    ],
                });
            })
            .catch(({ feedback }: any) => {
                feedbackApp.showFeedback({
                    title: feedback.title,
                });
            })
            .then(() => {
                setTimeout(() => {
                    disminss();
                }, 50);
            });
    };

    /**
     * vamos a la siguiente step
     */
    const handleNext = () => {
        setCurrentStep(2);
    };

    /**
     * Muestra el password 1
     */
    const togglePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };

    /**
     * muestra el password 2
     */
    const togglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };

    /**
     * handler the user interaction
     */
    const onHandlerInputChange = (customeEvent: CustomEvent) => {
        let { event, value } = customeEvent.detail;

        let name = event.target.name;

        if (name == "zipcode" && name.length > 5) {
            value = value.slice(0, 5);
        }

        setUser({ ...user, [name]: value });
    };

    /**
     * maneja el cambio de los radio buttons
     */
    const handleRadioChange = (customeEvent: CustomEvent) => {
        const selectedValue = customeEvent.detail.value;
        setSelectedGender(selectedValue);

        setUser({ ...user, gender: selectedValue });
    };

    /**
     * maneja el cambio de la fecha de nacimiento
     */
    const handleDateChange = (customEvent: CustomEvent) => {
        const selectedDate = customEvent.detail.value;

        if (DateTime.fromISO(selectedDate).isValid) {
            const formattedDate =
                DateTime.fromISO(selectedDate).toFormat("yyyy-MM-dd");

            setUser({ ...user, date_birth: formattedDate });
        }
    };

    /**
     * Maneja la seleccion de un estado
     */
    const handleStateChange = (CustomeEvent: CustomEvent) => {
        const newState = CustomeEvent.detail.value;

        setSelectedState(newState);
        setSelectedMunicipality(null);
        setSelectedCities(null);
    };

    /**
     * Manejjo de la selecion del municipo
     */
    const onHandlerMunicipalityChange = (e: CustomEvent) => {
        setSelectedMunicipality(e.detail.value);
        setSelectedCities(null);
    };

    /**
     * Manejo de la selecion de una ciudad
     */
    const onHandlerCityChange = (e: CustomEvent) => {
        const selectedCity = e.detail.value;

        setSelectedCities(selectedCity);

        setUser({ ...user, address_city_id: selectedCity.city_id });
    };

    /**
     * Validaciones de los campos
     *
     */

    const isNameValid = () => ({
        isValid: user.name !== "",
        message: "El nombre es requerido",
    });

    const isLastNameValid = () => ({
        isValid: user.last_name !== "",
        message: "El apellido paterno es requerido",
    });

    const isMembershipValid = () => ({
        isValid: UserMembership !== 0,
        message: "La membresía del usuario es requerida",
    });

    const isCellphoneValid = () => ({
        isValid: user.cellphone !== "" && user.cellphone.length === 10,
        message: "El teléfono es requerido",
    });
    const isDateBirthValid = () => ({
        isValid: user.date_birth !== "",
        message: "El año de nacimiento es requerido",
    });

    const isStreetValid = () => ({
        isValid: user.street !== "",
        message: "La calle del usuario es requerida",
    });

    const isExteriorNumberValid = () => ({
        isValid: user.outside_number !== "",
        message: "El número exterior es requerido",
    });

    const isColonyValid = () => ({
        isValid: user.colony !== "",
        message: "La colonia del usuario es requerida",
    });

    const isZipCode = () => ({
        isValid: user.zipcode !== "",
        message: "El código postal es obligatorio",
    });

    const isCityValid = () => ({
        isValid: user.address_city_id !== null,
        message: "La ciudad del usuario es requerida",
    });

    /**
     * validacion para el correo
     */
    const isEmailValid = () => {
        var mailformat =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const isEmail = mailformat.test(user.email);

        return {
            isValid: (user.email !== "" && isEmail) || user.email === "",
            message: "Campo requerido o incorrecto",
        };
    };

    const isPasswordValid = () => {
        if (user.password === "") {
            return {
                isValid: false,
                message: "La contraseña es requerida",
            };
        } else if (user.password !== user.password_confirmation) {
            return {
                isValid: false,
                message: "Las contraseñas no coinciden",
            };
        }
        return {
            isValid: true,
            message: "",
        };
    };

    const isStepOneValid = () => {
        return (
            isNameValid().isValid &&
            isLastNameValid().isValid &&
            isCellphoneValid().isValid &&
            isDateBirthValid().isValid &&
            isEmailValid().isValid &&
            isMembershipValid().isValid
        );
    };
    const isRegisterValid = () => {
        return (
            isNameValid().isValid &&
            isLastNameValid().isValid &&
            isCellphoneValid().isValid &&
            isDateBirthValid().isValid &&
            isPasswordValid().isValid &&
            isStreetValid().isValid &&
            isExteriorNumberValid().isValid &&
            isColonyValid().isValid &&
            isZipCode().isValid &&
            isCityValid().isValid
        );
    };
    const onChangeLocation = ({ latitude, longitude }: any) => {
        setUser((user: any) => {
            return {
                ...user,
                latitude,
                longitude,
            };
        });
    };
    const fechaMaximaValida = DateTime.now()
        .minus({ years: 18 })
        .toFormat("yyyy-MM-dd");

    /**
     * animacion del select
     */
    useEffect(() => {
        if (showFirstSelect) {
            anime({
                targets: ".ion-select-animation",
                opacity: [0, 1],
                translateY: [20, 0],
                duration: 700,
                easing: "easeInOutExpo",
            });
        }
    }, [showFirstSelect]);

    return (
        <IonPage className="create-member-page">
            <ToolBar title="Nuevo Miembro"></ToolBar>
            <IonContent className="ion-padding content-create-member">
                <div>
                    {/*first seccion*/}
                    {currentStep === 1 && (
                        <div className="titleForm">Datos Personales</div>
                    )}
                    {currentStep === 1 && (
                        <div>
                            <IonGrid>
                                {/*names seccion*/}
                                <IonRow>
                                    <IonCol size="12">
                                        <IonInput
                                            name="name"
                                            maxlength={50}
                                            className="inputs-create-member"
                                            labelPlacement="stacked"
                                            placeholder="Nombre(s)"
                                            value={user.name}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Nombre
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>
                                {/*surnames seccion*/}
                                <IonRow>
                                    <IonCol size="6" class="last-name">
                                        <IonInput
                                            name="last_name"
                                            className="inputs-create-member"
                                            labelPlacement="stacked"
                                            placeholder="Tu apellido"
                                            maxlength={50}
                                            value={user.last_name}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Apellido Paterno{" "}
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                    <IonCol size="6">
                                        <IonInput
                                            maxlength={50}
                                            className="inputs-create-member"
                                            name="second_last_name"
                                            labelPlacement="stacked"
                                            placeholder="Tu apellido"
                                            value={user.second_last_name}
                                            onIonInput={onHandlerInputChange}
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Apellido Materno
                                                <IonText color="medium">
                                                    (Opcional)
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>
                                {/*Memberchip seccion*/}
                                <IonRow>
                                    <IonCol
                                        size="12"
                                        className="membership-seccion ion-padding-top"
                                    >
                                        <div className="ion-padding-top text-label-dif">
                                            Membresia
                                            <IonText color="danger">*</IonText>
                                        </div>
                                        <IonSelect
                                            interface="action-sheet"
                                            className="membership-select select-create-member-page"
                                            toggleIcon={chevronDownOutline}
                                            expandedIcon={chevronUpOutline}
                                            placeholder="selecciona su membresia"
                                            mode="ios"
                                            value={UserMembership}
                                            onIonChange={handleMembershipChange}
                                        >
                                            <IonSelectOption
                                                value={
                                                    MEMBERSHIPS.ADMINISTRATOR
                                                }
                                            >
                                                Administrador
                                            </IonSelectOption>
                                            <IonSelectOption
                                                value={MEMBERSHIPS.GUEST}
                                            >
                                                Invitado
                                            </IonSelectOption>
                                        </IonSelect>
                                    </IonCol>
                                </IonRow>
                                {/*phone seccion*/}
                                <IonRow>
                                    <IonCol size="12">
                                        <IonItem className="phone">
                                            <IonInput
                                                className="inputs-create-member"
                                                name="cellphone"
                                                maxlength={10}
                                                labelPlacement="stacked"
                                                placeholder="Ingresa el número celular"
                                                value={user.cellphone}
                                                onIonInput={
                                                    onHandlerInputChange
                                                }
                                                type="tel"
                                                required
                                                ref={async (phoneInput) => {
                                                    if (phoneInput) {
                                                        const input =
                                                            await phoneInput.getInputElement();
                                                        phoneMask(input);
                                                    }
                                                }}
                                            >
                                                <div
                                                    className="inputs-create-member-text"
                                                    slot="label"
                                                >
                                                    Teléfono{" "}
                                                    <IonText color="danger">
                                                        *
                                                    </IonText>
                                                </div>
                                            </IonInput>
                                            <IonIcon
                                                className="icon"
                                                slot="end"
                                                icon={callOutline}
                                            />
                                        </IonItem>
                                    </IonCol>
                                </IonRow>
                                {/*gender seccion*/}
                                <IonRow className="gender-seccion">
                                    <IonText className="genderTitle">
                                        Género{" "}
                                        <IonText color="danger">*</IonText>
                                    </IonText>
                                    <IonCol size="12">
                                        <IonRadioGroup
                                            value={
                                                selectedGender || user.gender
                                            }
                                            onIonChange={handleRadioChange}
                                            className="gender-Buttons flex-row ion-justify-content-between ion-align-items.center"
                                        >
                                            <IonRadio
                                                mode="md"
                                                value="1"
                                                className="circle-radio ion-padding-top"
                                            >
                                                <p className="gender">
                                                    Masculino
                                                </p>
                                            </IonRadio>

                                            <IonRadio
                                                mode="md"
                                                value="2"
                                                className="circle-radio ion-padding-top"
                                            >
                                                <p className="gender">
                                                    Femenino
                                                </p>
                                            </IonRadio>

                                            <IonRadio
                                                mode="md"
                                                value="3"
                                                className="circle-radio ion-padding-top"
                                            >
                                                <p className="gender">Otro</p>
                                            </IonRadio>
                                        </IonRadioGroup>
                                    </IonCol>
                                </IonRow>
                                {/*born day seccion*/}
                                <IonRow>
                                    <IonCol>
                                        <IonItem
                                            className="bornDay born-seccion"
                                            id="auto-trigger"
                                        >
                                            <IonInput
                                                name="date_birth"
                                                labelPlacement="stacked"
                                                placeholder="DD/MM/YYYY"
                                                value={user.date_birth}
                                                className="inputs-create-member"
                                                onIonChange={handleRadioChange}
                                            >
                                                <div
                                                    className="inputs-create-member-text"
                                                    slot="label"
                                                >
                                                    Fecha de Nacimiento{" "}
                                                    <IonText color="danger">
                                                        *
                                                    </IonText>
                                                </div>
                                                <IonPopover
                                                    trigger="auto-trigger"
                                                    side="top"
                                                    alignment="center"
                                                    keepContentsMounted={true}
                                                >
                                                    <IonDatetime
                                                        size="cover"
                                                        presentation="date"
                                                        preferWheel={true}
                                                        showDefaultButtons={
                                                            true
                                                        }
                                                        doneText="Aceptar"
                                                        cancelText="Cancelar"
                                                        onIonChange={
                                                            handleDateChange
                                                        }
                                                        max={fechaMaximaValida}
                                                    ></IonDatetime>
                                                </IonPopover>
                                            </IonInput>

                                            <IonIcon
                                                className="icon"
                                                slot="end"
                                                icon={calendarOutline}
                                            />
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                {/* email seccion  */}
                                <IonRow>
                                    <IonCol>
                                        <IonItem className="email email-seccion">
                                            <IonInput
                                                name="email"
                                                labelPlacement="stacked"
                                                placeholder="tumail@gmail.com"
                                                value={user.email}
                                                maxlength={100}
                                                onIonInput={
                                                    onHandlerInputChange
                                                }
                                                className="inputs-create-member"
                                            >
                                                <div
                                                    className="inputs-create-member-text"
                                                    slot="label"
                                                >
                                                    E-mail{" "}
                                                    <IonText color="medium">
                                                        (opcional)
                                                    </IonText>
                                                </div>
                                            </IonInput>
                                            <IonIcon
                                                className="icon"
                                                slot="end"
                                                icon={mailOutline}
                                            />
                                        </IonItem>
                                    </IonCol>
                                </IonRow>
                                {/*Button Next seccion*/}
                                <div className="button-create-member ion-justify-content-center">
                                    <IonButton
                                        className="nextButton"
                                        onClick={handleNext}
                                        disabled={!isStepOneValid()}
                                    >
                                        Siguiente
                                    </IonButton>
                                </div>
                            </IonGrid>
                        </div>
                    )}

                    {/*seccond seccion*/}

                    {currentStep === 2 && (
                        <div className="titleForm ion-padding-top">
                            Ubicación
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div>
                            <IonGrid>
                                {/*street seccion*/}
                                <IonRow>
                                    <IonCol>
                                        <IonInput
                                            name="street"
                                            labelPlacement="stacked"
                                            placeholder="Nombre de la calle"
                                            value={user.street}
                                            type="text"
                                            maxlength={50}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                            className="inputs-create-member"
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Calle
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>

                                {/*numbers seccion*/}
                                <IonRow>
                                    <IonCol size="6" className="last-name">
                                        <IonInput
                                            maxlength={10}
                                            type="text"
                                            className="inputs-create-member"
                                            name="outside_number"
                                            label-placement="stacked"
                                            placeholder="Número"
                                            value={user.outside_number}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Núm. Exterior
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                    <IonCol size="6">
                                        <IonInput
                                            className="inputs-create-member"
                                            name="inside_number"
                                            labelPlacement="stacked"
                                            placeholder="Número"
                                            maxlength={10}
                                            type="text"
                                            value={user.inside_number}
                                            onIonInput={onHandlerInputChange}
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Núm. Interior{" "}
                                                <IonText color="medium">
                                                    (opcional)
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonInput
                                            name="colony"
                                            labelPlacement="stacked"
                                            placeholder="Nombre de la colonia"
                                            value={user.colony}
                                            type="text"
                                            maxlength={50}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                            className="inputs-create-member"
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Colonia
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>
                                {/*CP seccion*/}
                                <IonRow>
                                    <IonCol>
                                        <IonInput
                                            type="number"
                                            className="inputs-create-member"
                                            name="zipcode"
                                            maxlength={5}
                                            labelPlacement="stacked"
                                            placeholder="Número"
                                            value={user.zipcode}
                                            onIonInput={onHandlerInputChange}
                                            required
                                            counter={true}
                                        >
                                            <div
                                                className="inputs-create-member-text"
                                                slot="label"
                                            >
                                                Código Postal{" "}
                                                <IonText color="danger">
                                                    *
                                                </IonText>
                                            </div>
                                        </IonInput>
                                    </IonCol>
                                </IonRow>
                                {/*state seccion*/}
                                <IonRow className="states-seccion">
                                    <IonCol
                                        size="12"
                                        className="text-label-dif"
                                    >
                                        Estado{" "}
                                        <IonText color="danger">*</IonText>
                                    </IonCol>
                                    <IonCol size="12">
                                        <IonItem className="states">
                                            <IonIcon
                                                slot="start"
                                                src={marketInput}
                                            />

                                            <IonSelect
                                                className="states-select select-create-member-page"
                                                placeholder="Seleccionar estado"
                                                name="address_city_id"
                                                toggleIcon={chevronDownOutline}
                                                expandedIcon={chevronUpOutline}
                                                interface="action-sheet"
                                                onIonChange={handleStateChange}
                                                compareWith={(
                                                    o1: State,
                                                    o2: State
                                                ) => {
                                                    return o1 && o2
                                                        ? o1.state_id ===
                                                              o2.state_id
                                                        : o1 === o2;
                                                }}
                                                mode="ios"
                                                value={selectedState}
                                            >
                                                {states
                                                    .sort((a: any, b: any) =>
                                                        a.title.localeCompare(
                                                            b.title
                                                        )
                                                    )
                                                    .map((state: any) => (
                                                        <IonSelectOption
                                                            className="seccions"
                                                            key={state.state_id}
                                                            value={state}
                                                        >
                                                            {state.title.toUpperCase()}
                                                        </IonSelectOption>
                                                    ))}
                                            </IonSelect>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>
                                {/*municipalite and city seccion*/}
                                <IonRow className="states-seccion">
                                    <IonCol size="6" className="last-name">
                                        <div className="text-label-dif">
                                            Municipio
                                            <IonText color="danger">*</IonText>
                                        </div>
                                        <IonSelect
                                            className="select select-create-member-page"
                                            interface="action-sheet"
                                            toggleIcon={chevronDownOutline}
                                            expandedIcon={chevronUpOutline}
                                            placeholder="Selc. Municipio"
                                            onIonChange={
                                                onHandlerMunicipalityChange
                                            }
                                            disabled={!selectedState}
                                            mode="ios"
                                            compareWith={(
                                                o1: Municipality,
                                                o2: Municipality
                                            ) => {
                                                return o1 && o2
                                                    ? o1.municipality_id ===
                                                          o2.municipality_id
                                                    : o1 === o2;
                                            }}
                                            value={selectedMunicipality}
                                        >
                                            {allMunicipalities
                                                .sort(
                                                    (
                                                        a: Municipality,
                                                        b: Municipality
                                                    ) =>
                                                        a.title.localeCompare(
                                                            b.title
                                                        )
                                                )
                                                .map((municipality: any) => (
                                                    <IonSelectOption
                                                        key={
                                                            municipality.municipality_id
                                                        }
                                                        value={municipality}
                                                    >
                                                        {municipality.title}
                                                    </IonSelectOption>
                                                ))}
                                        </IonSelect>
                                    </IonCol>

                                    {/*city seccion*/}
                                    <IonCol size="6">
                                        <div className="text-label-dif">
                                            Ciudad
                                            <IonText color="danger">*</IonText>
                                        </div>
                                        <IonSelect
                                            className="select select-create-member-page"
                                            interface="action-sheet"
                                            toggleIcon={chevronDownOutline}
                                            expandedIcon={chevronUpOutline}
                                            placeholder="Sel. Ciudad"
                                            aria-required
                                            compareWith={(
                                                o1: City,
                                                o2: City
                                            ) => {
                                                return o1 && o2
                                                    ? o1.city_id === o2.city_id
                                                    : o1 === o2;
                                            }}
                                            value={selectedCities}
                                            onIonChange={onHandlerCityChange}
                                            disabled={
                                                !selectedMunicipality ||
                                                !selectedState
                                            }
                                            mode="ios"
                                        >
                                            {allCities
                                                .sort((a: City, b: City) =>
                                                    a.title.localeCompare(
                                                        b.title
                                                    )
                                                )
                                                .map((city: any) => (
                                                    <IonSelectOption
                                                        key={city.city_id}
                                                        value={city}
                                                    >
                                                        {city.title}
                                                    </IonSelectOption>
                                                ))}
                                        </IonSelect>
                                    </IonCol>
                                </IonRow>
                                {/*map seccion*/}
                                <IonRow>
                                    <IonCol
                                        size="12"
                                        className="mapText ion-padding-top"
                                    >
                                        <IonText className="mapText ion-padding-top">
                                            Ubicación Geográficamente de tu
                                            domicilio
                                        </IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size="12">
                                        <MapComponent
                                            latitude={user.latitude}
                                            longitude={user.longitude}
                                            onChangeLocation={onChangeLocation}
                                        ></MapComponent>
                                    </IonCol>
                                </IonRow>

                                {/*passwords seccion*/}
                                <IonRow>
                                    <IonCol>
                                        <IonItem className="password-seccion ion-padding-top">
                                            <IonInput
                                                maxlength={100}
                                                name="password"
                                                labelPlacement="stacked"
                                                type={
                                                    showPassword1
                                                        ? "text"
                                                        : "password"
                                                }
                                                placeholder="Ingresa una contraseña"
                                                value={user.password}
                                                onIonInput={(e) => {
                                                    onHandlerInputChange(e);
                                                }}
                                                required
                                                className="inputs-create-member"
                                            >
                                                <div
                                                    className="inputs-create-member-text"
                                                    slot="label"
                                                >
                                                    Password{" "}
                                                    <IonText color="danger">
                                                        *
                                                    </IonText>
                                                </div>
                                            </IonInput>
                                            <IonIcon
                                                className="icon"
                                                slot="end"
                                                icon={
                                                    showPassword1
                                                        ? eyeOutline
                                                        : eyeOffOutline
                                                }
                                                onClick={
                                                    togglePasswordVisibility1
                                                }
                                            />
                                        </IonItem>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem className="password-seccion ion-padding-top">
                                            <IonInput
                                                maxlength={100}
                                                name="password_confirmation"
                                                labelPlacement="stacked"
                                                type={
                                                    showPassword2
                                                        ? "text"
                                                        : "password"
                                                }
                                                placeholder="Ingresa nuevamente la contraseña"
                                                value={
                                                    user.password_confirmation
                                                }
                                                onIonInput={(e) => {
                                                    onHandlerInputChange(e);
                                                }}
                                                className="inputs-create-member"
                                            >
                                                <div
                                                    className="inputs-create-member-text"
                                                    slot="label"
                                                >
                                                    Confirmar Password{" "}
                                                    <IonText color="danger">
                                                        *
                                                    </IonText>
                                                </div>
                                            </IonInput>
                                            <IonIcon
                                                className="icon"
                                                slot="end"
                                                icon={
                                                    showPassword2
                                                        ? eyeOutline
                                                        : eyeOffOutline
                                                }
                                                onClick={
                                                    togglePasswordVisibility2
                                                }
                                            />
                                        </IonItem>
                                        {user.password ===
                                        user.password_confirmation ? null : (
                                            <IonText color="danger">
                                                Las contraseñas no coinciden.
                                            </IonText>
                                        )}
                                    </IonCol>
                                </IonRow>

                                {/*confirm button icon */}
                                <IonRow>
                                    <div className="button-create-member ion-justify-content-center">
                                        <IonButton
                                            className="nextButton"
                                            onClick={() => setCurrentStep(1)}
                                        >
                                            Atrás
                                        </IonButton>
                                        <IonButton
                                            className="finishButton"
                                            onClick={OnCreateMember}
                                            disabled={!isRegisterValid()}
                                        >
                                            Registrar
                                        </IonButton>
                                    </div>
                                </IonRow>
                            </IonGrid>
                        </div>
                    )}
                </div>
            </IonContent>
        </IonPage>
    );
};

export default CreateMember;
